var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path0, _g3, _g4, _g5, _path1, _path10, _g6, _path11, _path12, _path13, _g7, _path14, _path15, _path16, _path17, _g8, _g9, _g0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMySummaryDesktopOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_295_1",
    "data-name": "Component 295 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227.237,
    height: 176.927,
    viewBox: "0 0 227.237 176.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 51.577,
    height: 171.852,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 77.014,
    height: 176.927,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 18.038,
    height: 19.917,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 20.465,
    height: 16.838,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 14.966,
    height: 46.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 40.222,
    height: 138.377,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 6.502,
    height: 12.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 47.372,
    height: 26.276,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(0 5.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M15.686,14.338s-6.977,1.089-5.562,8.793,2.64,12.512,1.037,15.435a2.684,2.684,0,0,0,2.923,3.583c3.959,0,7.146-2.618,6.353-9.322s2.977-.765,2.977-8.118-4.333-13.765-7.727-10.371",
    transform: "translate(0.628 0.847)",
    fill: "#201712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M22.4,149.659s-.475,7.344-4.784,9.994a1.8,1.8,0,0,0-.868,1.527,1.22,1.22,0,0,0,1.219,1.219h6.221a2.15,2.15,0,0,0,2.01-1.382,13.143,13.143,0,0,0,.9-3.881V162.4h.552l1.19-6.369-.786-6.369Z",
    transform: "translate(1.058 9.453)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M36.267,149.659s.475,7.344,4.784,9.994a1.8,1.8,0,0,1,.868,1.527A1.22,1.22,0,0,1,40.7,162.4H34.479a2.153,2.153,0,0,1-2.01-1.382,13.142,13.142,0,0,1-.9-3.881V162.4h-.552l-1.19-6.369.786-6.369Z",
    transform: "translate(1.884 9.453)",
    fill: "#040504"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M12.16,69.8A73.338,73.338,0,0,0,10.509,85.66c0,9.154,6.2,34.584,6.2,34.584l5.889,34.771h5.831l-.584-39.193-1.21-28.243h1.792l1.495,28.645,1.818,38.791h5.8s1.646-33.673,1.646-34.678,4.261-19.316,4.261-35.706A49.036,49.036,0,0,0,38.7,64.876l-26.559,1.14Z",
    transform: "translate(0.664 4.098)",
    fill: "#0e1a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M21.066,27.026S7.2,24.559,2.937,40.474L1.249,43.4s4.727,4.052,8.667,4.052l2.927-5.065s-2.927,6.191.113,9.229-.225,17.671-.225,17.671,10.692,3.827,26.792,0c0,0-2.927-13.956-1.688-17.33s2.589-4.39,1.688-8.329l3.371,4.146A34.1,34.1,0,0,0,51.5,44.9l-2.185-3.19s-.091-12.047-7.428-13.844S30.65,26.657,30.65,26.657Z",
    transform: "translate(0.079 1.678)",
    fill: "#25dfe8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M20.543,27.007S17.721,28.75,19.3,40.455s1.688,30.39-1.239,34.329L9.5,73.658s3.489-16.77,2.139-21.157-1.576-8.442.562-12.044.225-12.6.225-12.6a17.86,17.86,0,0,1,8.112-.847",
    transform: "translate(0.6 1.697)",
    fill: "#074a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M29.993,26.584s2.756,6.7,1.518,12.21-1.236,31.627.62,35.454L40.29,72.9S37.6,48,38.27,45.257c0,0-2.814-11.967.7-17.635,0,0-2.814-1.667-8.974-1.038",
    transform: "translate(1.895 1.67)",
    fill: "#074a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M18.256,26.891c.574.017,1.149.061,1.721.133a12.607,12.607,0,0,0-1.721-.133m12.478-.314c-.461.014-.787.04-.974.061.023.044.047.087.068.13l.013.02a1.441,1.441,0,0,1,.125.655c-.011,1.832-2.19,5.439-5.473,5.439a4.714,4.714,0,0,1-1.147-.144,4.17,4.17,0,0,1-3.42-3.617,3.854,3.854,0,0,1,.279-2.1l-.212.009h0c-.033.021-1.3.856-1.642,4.972,3,.609,5.7,2.69,8.749,2.69.07,0,.139,0,.209,0a17.231,17.231,0,0,0,3.334-.763c.462-.869.95-1.78,1.447-2.7a28.409,28.409,0,0,0-1.352-4.642",
    transform: "translate(1.153 1.679)",
    fill: "#0fb8cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M12.7,27.925a15.066,15.066,0,0,0-7.029,5.658V46.241l.057.024a5.431,5.431,0,0,0,.582-.465C9.064,43.269,8.734,38.8,10.67,35.595a8.162,8.162,0,0,1,2.707-2.661,43.285,43.285,0,0,0-.676-5.009",
    transform: "translate(0.358 1.764)",
    fill: "#0fb8cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M18.35,26.87a16.812,16.812,0,0,0-6.067,1.122A43.124,43.124,0,0,1,12.958,33a8.191,8.191,0,0,1,5.122-1.127q.324.041.644.106c.339-4.117,1.609-4.951,1.642-4.972h-.012c-.572-.072-1.147-.117-1.721-.134l-.283,0",
    transform: "translate(0.776 1.697)",
    fill: "#303e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M30.631,26.568c-.235,0-.449,0-.638.01a28.41,28.41,0,0,1,1.352,4.642c.813-1.513,1.651-3.053,2.437-4.474a30.225,30.225,0,0,0-3.151-.178",
    transform: "translate(1.895 1.678)",
    fill: "#303e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M24.653,42.119H24.8A2.778,2.778,0,0,1,27.582,44.9v3.8A2.778,2.778,0,0,1,24.8,51.472h-.151a2.778,2.778,0,0,1-2.778-2.778V44.9a2.778,2.778,0,0,1,2.778-2.778",
    transform: "translate(1.382 2.661)",
    fill: "#0e1a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M22.8,44.7h0a.387.387,0,0,1-.387-.387v-.9a.387.387,0,0,1,.774,0v.9A.387.387,0,0,1,22.8,44.7Z",
    transform: "translate(1.416 2.718)",
    fill: "#074a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M2.015,42.918a18.381,18.381,0,0,0,7.534,3.488s-1.457,5.635-2.3,6.477l13.89-2.607a1.063,1.063,0,0,0,.872-1.043c0-.923.193-2.3,1.266-2.7v2.5s6.379-1.152,6.874-1.152.654.5,0,1.152a5.041,5.041,0,0,1-1.235.933s.986.441.158,1.453a.784.784,0,0,1,.075,1.107l-.061.063s.356.918-.375.918c0,0,.061.632-.716.632s-3.19.728-5.509,0c-1.011-.319-13.562,4.8-19.562,6.357s-.911-17.582-.911-17.582",
    transform: "translate(0 2.711)",
    fill: "#f48568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M19.978,53.3c-1.7,0-4.008,1.519-5.57,1.928-3.33.872-5.9.72-8.736,1.992v1.7c5.4-1.73,12.734-4.581,15.451-5.289a1.907,1.907,0,0,0-1.145-.333",
    transform: "translate(0.358 3.367)",
    fill: "#ba6252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M23.125.7a14,14,0,0,1-3.205,1.131,7.811,7.811,0,0,0-5.373,7.636c0,4.431.086,7.888,3.065,10.868s2.871,3.083,4.572,4.784,6.273-.99,8.484-3.205,3.866-4.619,3.3-8.2-.095-5.468-1.791-8.956S25.117-1.293,23.125.7",
    transform: "translate(0.919 0)",
    fill: "#201712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M17.456,12.972s-.44,6.055,2.311,7.981,1.651,5.944.826,6.77a4.169,4.169,0,0,0,2.807,6.33c4.4,1.1,7.266-4.4,6.495-5.944s-3.3-4.572-1.817-7.43,1.941-2.367,1.941-6.55S28.9,7.084,26.371,6.148s-8.091-.826-8.916,6.824",
    transform: "translate(1.101 0.363)",
    fill: "#f48568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M21.35,23.7a4.946,4.946,0,0,1-.926,2.893,3.888,3.888,0,0,0-.335.611h.017a4.322,4.322,0,0,1,.318-.609A4.942,4.942,0,0,0,21.35,23.7",
    transform: "translate(1.269 1.497)",
    fill: "#80756f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M20.107,26.991h0",
    transform: "translate(1.269 1.705)",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M20.125,26.992h-.017a3.851,3.851,0,0,0-.279,2.1,4.15,4.15,0,0,1,.3-2.1",
    transform: "translate(1.25 1.705)",
    fill: "#e5ca90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M17.43,13.324h0v0",
    transform: "translate(1.101 0.842)",
    fill: "#80756f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M18.558,13.258a9.939,9.939,0,0,1-1.129.07v.063c0,1.757.241,5.62,2.338,7.087a4.332,4.332,0,0,1,1.751,3.876,4.954,4.954,0,0,1-.925,2.9,4.106,4.106,0,0,0-.318.609h0a4.147,4.147,0,0,0-.3,2.1c.006.044.014.088.022.132.413-.031.645-.548.757-.972l.9-3.447a3.532,3.532,0,0,1,1.363-2.36c.515-.287,1.276-.438,1.334-1.025a.851.851,0,0,0-.5-.773,3.439,3.439,0,0,0-.939-.257,5.944,5.944,0,0,1-4.362-8",
    transform: "translate(1.101 0.837)",
    fill: "#fcc9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M17.205,13.925s5.009.275,7.046-3.413,2.531-2.7,2.531-2.7,1.542.165,1.542,4.733,1.425,5.14,1.425,5.14,1.657,1.465,1.657-2.883S29.149,3.742,25.24,3.742s-9.245,2.917-8.034,10.183",
    transform: "translate(1.076 0.236)",
    fill: "#201712"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M14.551,8.845c-.007.181-.01.361,0,.544a28.977,28.977,0,0,0,.056,3.069c-.051-.971-.056-1.991-.056-3.07-.005-.182,0-.363,0-.543m0-.019v0m0-.019h0m7.071-7.563c-.441.145-.994.315-1.683.505a14.075,14.075,0,0,0,1.678-.485l.005-.02",
    transform: "translate(0.918 0.079)",
    fill: "#d1eef9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M20.483,5.238a2.822,2.822,0,0,1-.287.393c.111-.084.222-.165.336-.241-.015-.051-.031-.1-.049-.152m1.134-3.976a13.739,13.739,0,0,1-1.678.484l-.02.006a7.812,7.812,0,0,0-5.368,7.053v.039c-.007.18-.01.359,0,.542,0,1.079.005,2.1.055,3.07q.1,1.4.336,2.792l.141-.031a1.4,1.4,0,0,0,.827-1.276c.047-.538-.058-1.082.016-1.617A3.99,3.99,0,0,1,17.4,10.034a7.425,7.425,0,0,1,2.169-3.873.933.933,0,0,1-.458.119.948.948,0,0,1-.691-.3c-.86-1.151,1.939-2.794,2.536-3.475a3.1,3.1,0,0,0,.663-1.244",
    transform: "translate(0.919 0.08)",
    fill: "#80756f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M20.362,5.145c-.114.077-.225.156-.336.241a2.736,2.736,0,0,1-.609.518.077.077,0,0,1-.02.012,7.42,7.42,0,0,0-2.168,3.872c.056-.041.114-.083.172-.123a15.419,15.419,0,0,0,2.312-1.9,2.673,2.673,0,0,0,.649-2.618",
    transform: "translate(1.088 0.325)",
    fill: "#80756f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M27.324,24.059l0,0a9.767,9.767,0,0,0,1.074,2.57,18.632,18.632,0,0,1-1.071-2.572M24.453,0c-.067,0-.134,0-.2.005h0c.066,0,.132-.005.2-.005,2.433,0,5.821,2.109,7.106,4.753,1.7,3.488,1.222,5.373,1.791,8.956a7.757,7.757,0,0,1-1.139,5.59,7.761,7.761,0,0,0,1.143-5.592c-.566-3.583-.095-5.468-1.791-8.956C30.277,2.109,26.886,0,24.453,0",
    transform: "translate(1.532)",
    fill: "#8198a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M29.141,26.756l.013.027a1.426,1.426,0,0,1,.125.649,1.441,1.441,0,0,0-.125-.655l-.013-.02",
    transform: "translate(1.841 1.69)",
    fill: "#9e7022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M24.452,0c-.067,0-.133,0-.2.005.082.479.725.908,1,1.313a5.941,5.941,0,0,1,1.048,3.018c2.966,1.448,4.644,6.955,4.644,10.7,0,2.6-.591,3.12-1.067,3.12a1.016,1.016,0,0,1-.59-.237h0a22.554,22.554,0,0,1-1.646,3.118,4.3,4.3,0,0,0-.325,3.019l0,0,0-.01A16.1,16.1,0,0,0,30.054,21.9a15.1,15.1,0,0,0,2.157-2.6,7.757,7.757,0,0,0,1.139-5.59c-.57-3.583-.095-5.468-1.791-8.956C30.273,2.11,26.884,0,24.452,0",
    transform: "translate(1.532 0)",
    fill: "#251713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M26.29,7.459c-.308,0-.98.419-2.306,2.818A5.906,5.906,0,0,1,21.8,12.5a8.283,8.283,0,0,0,.779,7.484c.7,1.043,1.653,1.914,2.255,3.025a7.138,7.138,0,0,1,.621,4.656,13.561,13.561,0,0,1-1.78,4.417,16.54,16.54,0,0,0-.944,1.732c.136.044.279.085.425.121a4.709,4.709,0,0,0,1.146.145c3.28,0,5.457-3.6,5.473-5.434A1.447,1.447,0,0,0,29.653,28a.209.209,0,0,1-.014-.027,18.484,18.484,0,0,1-1.055-1.815,9.732,9.732,0,0,1-1.074-2.57,4.285,4.285,0,0,1,.325-3.019,22.521,22.521,0,0,0,1.645-3.117c-.029-.013-1.424-.62-1.424-5.14,0-4.568-1.542-4.733-1.542-4.733a.251.251,0,0,0-.226-.121",
    transform: "translate(1.342 0.471)",
    fill: "#ba6252"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M26.462,4.08a5.933,5.933,0,0,1-.927,3.573c-.738,1.157-1.851,2.02-2.689,3.111a8.283,8.283,0,0,0-1.077,1.954,5.906,5.906,0,0,0,2.182-2.227c1.326-2.4,2-2.818,2.306-2.818a.248.248,0,0,1,.225.121s1.542.165,1.542,4.733c0,4.521,1.4,5.128,1.425,5.14h0a1.011,1.011,0,0,0,.589.237c.476,0,1.067-.523,1.067-3.12,0-3.749-1.677-9.256-4.644-10.7",
    transform: "translate(1.375 0.258)",
    fill: "#251713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M10.73,88.805q.054.573.122,1.145c-.046-.391-.086-.774-.122-1.145m17.713-1.559H26.651l.268,6.255h.006l-.268-6.251h1.786v0M10.2,71.021l-.005,0,1.618.213c-.082.448-.159.894-.234,1.343q.115-.675.243-1.346L10.2,71.021m31.342-.882L41,70.227a48.975,48.975,0,0,1,1.814,7.342l.017-.144a45.7,45.7,0,0,0-1.83-7.2l.535-.091",
    transform: "translate(0.644 4.43)",
    fill: "#8198a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M32.561,67.861a58.745,58.745,0,0,1-7.725.519,52.6,52.6,0,0,1-5.413-.273,10.7,10.7,0,0,1-1.429,4.087L11.8,71.378q-.128.673-.243,1.346a77.841,77.841,0,0,0-1.042,12.75q.032,1.743.195,3.474c.036.371.077.754.122,1.145.029.247.061.492.094.738a32.727,32.727,0,0,0,11.594,2.724c1.094.069,2.189.1,3.283.1q.549,0,1.1-.01l-.268-6.256h1.792v0h.006l.319,6.2c2.779-.12,5.557-.385,8.328-.65a18.363,18.363,0,0,0,5.956-1.252l-.623-6.007a22.715,22.715,0,0,1,.038-5.028l.351-2.939a48.994,48.994,0,0,0-1.814-7.341l-7.623,1.261a14.148,14.148,0,0,1-.8-3.771",
    transform: "translate(0.664 4.287)",
    fill: "#1f1840"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M31.58,62.476A18.858,18.858,0,0,1,25.7,65.821a50.888,50.888,0,0,1-6.624,1.57c-.057.366-.119.719-.184,1.056a52.271,52.271,0,0,0,5.412.274,58.772,58.772,0,0,0,7.726-.519c-.192-1.6-.342-3.566-.452-5.726",
    transform: "translate(1.193 3.946)",
    fill: "#0fb8cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M19.627,67.1a29.825,29.825,0,0,0-4.054,1.075A18.44,18.44,0,0,0,10.2,71.214l1.622.214,6.194.815a10.728,10.728,0,0,0,1.43-4.088c.065-.338.127-.691.184-1.057",
    transform: "translate(0.644 4.238)",
    fill: "#303e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M36.424,54.984a18.906,18.906,0,0,1-5.6,7.965c.11,2.16.259,4.125.451,5.726a14.116,14.116,0,0,0,.8,3.771L39.7,71.185l.537-.088c0-.024-.434-4.008-.907-8.955q-1.531-3.548-2.907-7.157",
    transform: "translate(1.947 3.473)",
    fill: "#303e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M26.872,39.248l-.005.01a9.28,9.28,0,0,0,.7.729l.129.12c.233.213.512.454.83.7.15.116.309.233.476.349.2.138.409.275.63.408a10.333,10.333,0,0,0,1.063.559l.263.114.231.091,0-.04a11.215,11.215,0,0,1-4.322-3.04",
    transform: "translate(1.697 2.479)",
    fill: "#cea313"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M30.937,42.107l0,.04c.2.074.4.142.6.2.1.029.191.055.288.08l.1.023,0-.015-.1-.026q-.448-.134-.881-.305",
    transform: "translate(1.954 2.66)",
    fill: "#26407c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M41.741,69.894h0Z",
    transform: "translate(2.636 4.415)",
    fill: "#7fa3b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M41.671,69.891c.023,0,.047,0,.07,0Z",
    transform: "translate(2.632 4.415)",
    fill: "#7fa3b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M39.264,62.923v0Zm-7.4-20.491q1.982,6.76,4.493,13.345v0q-2.507-6.577-4.491-13.34h0",
    transform: "translate(2.013 2.68)",
    fill: "#26407c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M36.092,54.98v0Q37.466,58.593,39,62.141l0-.011q-1.529-3.545-2.9-7.151",
    transform: "translate(2.28 3.473)",
    fill: "#353662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M31.861,42.418l0,.015h0l0-.015h0",
    transform: "translate(2.013 2.679)",
    fill: "#2e3867"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M31.368,40.693h0q.257.915.524,1.827h0q-.268-.911-.525-1.827",
    transform: "translate(1.981 2.57)",
    fill: "#181942"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(-8.005 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_277_6",
    "data-name": "Component 277 \\u2013 6",
    transform: "translate(41.333 -11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M9.657,152.8l-1.083,7.073c.247,4.346,3.023,3.909,6.218,2.677l3.045-5.866Z",
    transform: "translate(0.47 9.153)",
    fill: "#f1a8ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M8.636,159.468,7.5,165.447a1.622,1.622,0,0,0,1.282,1.9,1.588,1.588,0,0,0,.3.029H25.728s.051-4.335-2.11-5.227-7.167-.212-7.383-2.677H13.259s.217,3.292-1.942,2.677a4.02,4.02,0,0,1-2.681-2.678",
    transform: "translate(0.409 9.553)",
    fill: "#141f45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M37.228,152.8l1.168,7.073c.247,4.346,3.023,3.909,6.217,2.677l.987-7Z",
    transform: "translate(2.039 9.153)",
    fill: "#f1a8ba"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M38.4,159.468l-1.139,5.979a1.622,1.622,0,0,0,1.282,1.9,1.588,1.588,0,0,0,.3.029H55.488s.052-4.335-2.11-5.227-7.167-.212-7.383-2.677H43.019s.217,3.292-1.942,2.677a4.018,4.018,0,0,1-2.68-2.678",
    transform: "translate(2.04 9.553)",
    fill: "#141f45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M45.755,75.149l1.334,16.814,1.66,26.4c.15,2.374,1.221,5.537.024,7.589l-1.793,37.2-9.112-.819s-6.759-33.886-2.351-44.481L29.909,91.32l1.259-5.858Z",
    transform: "translate(1.639 4.502)",
    fill: "#00c9d3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M15.221,75.287l-1.257,10.6a22.754,22.754,0,0,0-.038,5.012l2.73,26.45s-5.553,13.1-8.081,43.234l9.563,3.254L30,123.868a8.612,8.612,0,0,0,1.67-4.573l1.9-29.7q11.463-3.448,13.359-14.449Z",
    transform: "translate(0.47 4.502)",
    fill: "#00c9d3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M55.457,43.414l2.531,6.87,8-19.979,4.407,1.84s-5.8,28.18-10.315,30.933-15.3-17.7-15.3-17.7Z",
    transform: "translate(2.453 1.815)",
    fill: "#f1a8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(47.231 45.229)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M44.778,44.636l10.679-1.963.949,2.587c-.456.152-1.061.207-1.43.33a9.714,9.714,0,0,0-1.955.868,5.087,5.087,0,0,0-2.591,3.662c-.2,2.037,1.217,3.837,2.554,5.382l3.494,4.041c.756.874,1.688,1.827,2.841,1.739a3.777,3.777,0,0,0,2.38-1.7l1.117-1.37c-.926,2.075-1.855,3.58-2.736,4.118-4.509,2.757-15.3-17.7-15.3-17.7",
    transform: "translate(-44.778 -42.673)",
    fill: "#250b11"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M34.082,26.456s-22.178-1.133-23.416,0S0,45.747,0,45.747a11.122,11.122,0,0,0,5.168,3.342c3.086.8,11.687,1.1,11.687,1.1L14.64,77.1a1.049,1.049,0,0,0,.957,1.133c.03,0,.06,0,.09,0l31.7-.138a1.064,1.064,0,0,0,1.055-1.027l1.114-29.632,9.436-4.253s-5.82-13.912-7.054-14.532-17.857-2.2-17.857-2.2",
    transform: "translate(0 1.555)",
    fill: "#009cdd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M34.082,26.456s-22.178-1.133-23.416,0S0,45.747,0,45.747a11.122,11.122,0,0,0,5.168,3.342c3.086.8,11.687,1.1,11.687,1.1L14.64,77.1a1.049,1.049,0,0,0,.957,1.133c.03,0,.06,0,.09,0l31.7-.138a1.064,1.064,0,0,0,1.055-1.027l1.114-29.632,9.436-4.253s-5.82-13.912-7.054-14.532-17.857-2.2-17.857-2.2",
    transform: "translate(0 1.555)",
    fill: "#009cdd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M34.082,26.456s-22.178-1.133-23.416,0S0,45.747,0,45.747a11.122,11.122,0,0,0,5.168,3.342c3.086.8,11.687,1.1,11.687,1.1L14.64,77.1a1.049,1.049,0,0,0,.957,1.133c.03,0,.06,0,.09,0l31.7-.138a1.064,1.064,0,0,0,1.055-1.027l1.114-29.632,9.436-4.253s-5.82-13.912-7.054-14.532-17.857-2.2-17.857-2.2",
    transform: "translate(0 1.555)",
    fill: "#20c5a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(38.531 28.477)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M49.941,28.6c-.8-.4-8.15-1.215-13.167-1.73-.081.042-.163.083-.244.126l7.546,1.136a6.227,6.227,0,0,1,6.046,4.333l5.6,11.242,1.274-.574S51.175,29.217,49.941,28.6",
    transform: "translate(-36.53 -26.867)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(35.651 33.503)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M43.8,73.754c3.2-4,1.713-23.992,2.6-34.434s2.369-7.252,2.369-7.252L47.746,47.083l-.038.017-.051,1.341L46.595,76.731a1.064,1.064,0,0,1-1.055,1.027L33.8,77.809s6.8-.056,10-4.055",
    transform: "translate(-33.799 -31.609)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(0.002 27.526)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M10.231,49.785c.492.042.984.081,1.467.117l.479.034.236.016.465.031.228.014.445.028.216.013c.713.041,1.351.073,1.861.1l.149.006c.675.031,1.086.046,1.086.046L14.649,77.1a1.041,1.041,0,0,0,.025.333,1.059,1.059,0,0,0,.072.2,1.046,1.046,0,0,0,.949.6l-.15,1.263-1.108,9.338c-.022.185-.041.372-.059.559a1.06,1.06,0,0,1-.011.106q-.054.6-.075,1.208-.011.318-.014.627,0,.628.025,1.255.014.318.038.626c.016.206.034.414.056.625l2.73,26.45s-5.553,13.1-8.081,43.234l2.41.82c3.864-14.494,9.614-43.117,10.1-43.111,4.43.059.046-10.54.046-10.54-1.576-3.8.174-7.806-.394-13.21-.351-3.345,2.683-12.989,1.543-16.151-.591-1.64,12.143-1.547,11.552-3.187-.547-1.52-14.421-4.77-14.84-6.334-3.059-11.366,1.043-23.5,6.962-33.664a18.439,18.439,0,0,1,2.919-4.028,20.236,20.236,0,0,1,3.375-2.482l5.929-3.752c.379-.24.949-.515,1.576-.818l-.265-.028-.072-.007-.275-.029h-.024l-1.452-.149h-.022c-1.016-.106-1.908-.192-2.594-.259h-.052l-.151-.015H35.3l-.466-.046-.115-.012h-.028l-.438-.042-.126-.012h-.038s-22.178-1.133-23.416,0a2.022,2.022,0,0,0-.226.268c-.246.332-.607.9-1.048,1.646l-.169.286q-.172.3-.36.618l-.19.33C5.531,35.119,0,45.762,0,45.763a8.865,8.865,0,0,0,.7.727l.128.12c.231.212.508.453.824.7.149.116.307.232.473.348.2.138.406.275.625.407a9.828,9.828,0,0,0,1.055.558c.085.039.173.076.261.113a8.7,8.7,0,0,0,.822.293c.095.029.19.055.286.079a24.953,24.953,0,0,0,3.128.508c.627.053,1.275.116,1.932.173",
    transform: "translate(-0.002 -25.97)",
    fill: "#250b11"
  }))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M6.159,48.177c-.367-.065-.7-.135-.982-.212A11.122,11.122,0,0,1,.009,44.623a9.119,9.119,0,0,0,4.747,1.533c.933.031,1.313.9,1.4,2.021",
    transform: "translate(0 2.673)",
    fill: "#141f45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M41.584,11.9a44.15,44.15,0,0,0-.837,5.048c-.168,2.1-.5,4.544-3.349,5.469s-2.426.673-2.426.673c-.095,2.028,1.025,3.16,1.828,4.854a7.947,7.947,0,0,1-9.032.377L26.1,27.258s3-5.469,1.91-7.994-.833-7.9-.833-7.9.884-2.177,4.444-2.888c3.2-.635,11.06-2.894,9.968,3.416",
    transform: "translate(1.43 0.453)",
    fill: "#f1a8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(36.613 10.912)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M35.208,22.241c.844-.654,2.088-.652,2.848-1.405a2.813,2.813,0,0,0,.667-2.161c-.043-.776-.261-1.532-.353-2.3a3.3,3.3,0,0,1,.39-2.248c.459-.677,1.139-1.079,1.371-1.908.154-.541.08-1.564.7-1.861a.525.525,0,0,1,.371-.043,6.056,6.056,0,0,1-.092,1.421,44.15,44.15,0,0,0-.837,5.048c-.168,2.1-.5,4.544-3.349,5.469-1.313.424-1.931.6-2.215.669a1.553,1.553,0,0,1,.5-.677",
    transform: "translate(-34.711 -10.295)",
    fill: "#fff"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M16.517,48.518h-.033a.212.212,0,0,1-.175-.241c1.987-12.825-1.062-17.763-1.093-17.806a.212.212,0,0,1,.039-.3.21.21,0,0,1,.3.038.177.177,0,0,1,.019.03c.131.2,3.164,5.123,1.16,18.1a.211.211,0,0,1-.213.172",
    transform: "translate(0.831 1.805)",
    fill: "#11172d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M46.934,45.254h-.019a.212.212,0,0,1-.191-.229l1.124-12.989a.212.212,0,1,1,.422.037L47.147,45.062a.212.212,0,0,1-.213.192",
    transform: "translate(2.56 1.908)",
    fill: "#11172d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M41.615,67.526s-27.181,5.559-27.977,3.755A178.549,178.549,0,0,1,4.5,46.115C16.135,43.5,16.63,48.6,16.63,48.6l2.9,16.334,20.865-1.788A3.8,3.8,0,0,1,41.7,60.022l1.676-3.233a.822.822,0,0,1,1.635.06l-.949,2.463,4.008-1.927,3.762.139a.808.808,0,0,1,.035,1.613l-.023,0-2.6.135-.9.675.428.1a1.12,1.12,0,0,1-.288,2.211l-.548-.021.014.284.583.223a.723.723,0,0,1,.439.865l-.031.114a.72.72,0,0,1-.8.53L47.1,64.1l-.137.318.3.106a.725.725,0,0,1,.44.923.737.737,0,0,1-.114.208.719.719,0,0,1-.726.258l-.941-.212s-2.748,1.9-4.311,1.83",
    transform: "translate(0.247 2.718)",
    fill: "#f1a8ba"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(4.747 48.092)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M16.634,48.6l.024.14c-1.092-.248-2.071-.974-3.254-1.091a7,7,0,0,0-3.932.742l4.74,15.31c.56,1.809,1.266,3.8,2.945,4.664a7.152,7.152,0,0,0,4.315.266l13.638-1.988c3.009-.439,6.21-.965,8.467-3.011,1.138-1.032,1.947-2.381,3.026-3.474a4.578,4.578,0,0,1,4.1-1.6,2.968,2.968,0,0,1,1.168.583h-.02l-2.6.135-.9.675.428.1a1.12,1.12,0,0,1-.288,2.211l-.548-.021.014.284.583.223a.724.724,0,0,1,.439.865l-.031.114a.72.72,0,0,1-.8.53L47.107,64.1l-.137.318.3.106a.725.725,0,0,1,.44.923.737.737,0,0,1-.114.208.717.717,0,0,1-.726.258l-.941-.212s-2.754,1.9-4.316,1.836c0,0-27.181,5.559-27.977,3.755A178.55,178.55,0,0,1,4.5,46.123C16.135,43.5,16.634,48.6,16.634,48.6",
    transform: "translate(-4.5 -45.374)",
    fill: "#250b11"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M26.218,4.76C29.351,3.488,37.472,3.315,38.149,0c0,0,4.737,1.785,4.991,5.525a6.091,6.091,0,0,1-.913,4.223c.755,2.032-.949,4.72-.949,4.72a6.648,6.648,0,0,0-.691-3.71,3.968,3.968,0,0,1-1.343.037A32.068,32.068,0,0,1,32.9,8.925l.949,1.774a3.036,3.036,0,0,1-1.2,4.091l-.339,4.216s-.6-4.082-2.622-3.451-1.776,3.485-.507,4.165H28.121a13.893,13.893,0,0,1-4.192-9.946s-.844-3.74,2.289-5.015",
    transform: "translate(1.305)",
    fill: "#17171f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M36.555,25.213s-4.124,2.915-10.41-.833L25.13,26.288S27,29.044,32,29.134a7.6,7.6,0,0,0,5.737-2.088Z",
    transform: "translate(1.377 1.461)",
    fill: "#143b6e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M65.064,31.57s-2-3.537-2-5.592v-4.6a.818.818,0,0,1,1.629-.112L65,23.523a.579.579,0,0,0,1.144.02l1.287-7.37a.932.932,0,0,1,1.08-.76c.027.005.054.011.08.018a.937.937,0,0,1,.689,1l-.427,4.419a10.616,10.616,0,0,1,1.851.124,3.813,3.813,0,0,1,.6,1.26.761.761,0,0,0,.578.5l.072.014a.767.767,0,0,1,.6.562l.227.879a.769.769,0,0,0,.378.483.769.769,0,0,1,.383.842l-.43,1.944-3.755,5.717Z",
    transform: "translate(3.455 0.923)",
    fill: "#f1a8ba"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M67.673,28.276a2.459,2.459,0,0,0-.643-3.315.721.721,0,0,1-.239-.933l1.853-3.487-1.361,3.286a.811.811,0,0,0,.428,1.061.8.8,0,0,0,.368.063H68.1c.591-.061,1.266-1.272,1.574-1.866a.19.19,0,1,1,.293.232,4.475,4.475,0,0,0-1.188,1.874c.043.374.333.954,1.907-.106a3.115,3.115,0,0,0-.852.861c-.247.537-.165.992.9.785a4.433,4.433,0,0,0,2.016-1.24l.382.587L72.9,27.154s-3.906-.826-5.228,1.122",
    transform: "translate(3.655 1.231)",
    fill: "#e26a83"
  }))))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "graphs",
    transform: "translate(171.236 76.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 53,
    height: 63,
    transform: "translate(0)",
    fill: "#765f59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(53 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 3,
    height: 14,
    fill: "#e55757"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 3,
    height: 14,
    transform: "translate(0 14)",
    fill: "#ed9f0e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 3,
    height: 14,
    transform: "translate(0 28)",
    fill: "#20c5a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 3,
    height: 14,
    transform: "translate(0 42)",
    fill: "#ffd958"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 47,
    height: 56,
    transform: "translate(3 4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    x2: 39.966,
    transform: "translate(6.535 10.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x2: 39.966,
    transform: "translate(6.535 15.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x2: 39.966,
    transform: "translate(6.535 21.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x2: 39.966,
    transform: "translate(6.535 27.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x2: 39.966,
    transform: "translate(6.518 33.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x2: 39.966,
    transform: "translate(6.518 39.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    x2: 39.966,
    transform: "translate(6.518 45.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x2: 39.966,
    transform: "translate(6.518 51.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 9)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 20)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 14)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 26)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 32)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 38)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 44)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(5 50)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    x1: 4,
    transform: "translate(1.5 10.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x1: 4,
    transform: "translate(1.5 15.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    x1: 4,
    transform: "translate(1.5 21.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    x1: 4,
    transform: "translate(1.5 27.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    x1: 4,
    transform: "translate(1.5 33.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    x1: 4,
    transform: "translate(1.5 39.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    x1: 4,
    transform: "translate(1.5 45.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    x1: 4,
    transform: "translate(1.5 51.5)",
    fill: "none",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeWidth: 1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "paper",
    transform: "translate(131.986 58.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M936-3009h21.983v22.7l-5.325,5.325H936Z",
    transform: "translate(-936 3009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M955.735-2986.262h-5.29v5.283Z",
    transform: "translate(-933.752 3009)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 7,
    transform: "translate(3.5 5.5)",
    fill: "none",
    stroke: "#fdcb6e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x2: 15,
    transform: "translate(3.5 19.5)",
    fill: "none",
    stroke: "#ed9f0e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x2: 10.648,
    transform: "translate(3.5 9.5)",
    fill: "none",
    stroke: "#fdcb6e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x2: 10.648,
    transform: "translate(3.5 12.262)",
    fill: "none",
    stroke: "#fdcb6e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x2: 14.983,
    transform: "translate(3.5 15.023)",
    fill: "none",
    stroke: "#fdcb6e",
    strokeWidth: 1
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "paper-2",
    "data-name": "paper",
    transform: "translate(104 93.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1764-2",
    "data-name": "Path 1764",
    d: "M936-3009h21.983v22.7l-5.325,5.325H936Z",
    transform: "translate(-936 3009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765-2",
    "data-name": "Path 1765",
    d: "M955.735-2986.262h-5.29v5.283Z",
    transform: "translate(-933.751 3009)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112-2",
    "data-name": "Line 112",
    x2: 15,
    transform: "translate(3.5 5.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x2: 15,
    transform: "translate(3.5 9.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 15,
    transform: "translate(3.5 13.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115-2",
    "data-name": "Line 115",
    x2: 15,
    transform: "translate(3.5 17.5)",
    fill: "none",
    stroke: "#c1c1c1",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySummaryDesktopOverlay);
export default __webpack_public_path__ + "static/media/mySummaryDesktopOverlay.3c426bdafb225dde8eec5d735a12bf86.svg";
export { ForwardRef as ReactComponent };